import sizeImage from './sizeImage';

/**
 * Generates a srcset from an image URL.
 * @param {string} src
 * @param {number[]} widths
 * @param {object} params Extra parameters for the sizeImage call.
 * @returns {string}
 */
const makeSrcSet = (src, widths = [180, 320, 640, 1080], params = {}) => {
  const sources = widths.map((width) => {
    const resizedUrl = sizeImage({ ...params, width, src });
    return `${resizedUrl} ${width}w`;
  });
  return sources.join(',');
};

export default makeSrcSet;
